/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  APIKeyPolicyGrant,
  APIKeyPolicyGrant$Outbound,
  APIKeyPolicyGrant$outboundSchema,
} from "./apikeypolicygrant.js";

export type UpdateKeyPolicyRequestBody = {
  /**
   * The ID of the key.
   */
  id: string;
  /**
   * The key's complete policy. An empty list removes every grant.
   */
  policyGrants: Array<APIKeyPolicyGrant>;
};

/** @internal */
export type UpdateKeyPolicyRequestBody$Outbound = {
  id: string;
  policy_grants: Array<APIKeyPolicyGrant$Outbound>;
};

/** @internal */
export const UpdateKeyPolicyRequestBody$outboundSchema: z.ZodMiniType<
  UpdateKeyPolicyRequestBody$Outbound,
  UpdateKeyPolicyRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    policyGrants: z.array(APIKeyPolicyGrant$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyGrants: "policy_grants",
    });
  }),
);

export function updateKeyPolicyRequestBodyToJSON(
  updateKeyPolicyRequestBody: UpdateKeyPolicyRequestBody,
): string {
  return JSON.stringify(
    UpdateKeyPolicyRequestBody$outboundSchema.parse(updateKeyPolicyRequestBody),
  );
}
